import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { allBlogPosts } from '../blogData'; 

function SinglePostPage() {
  const { slug } = useParams();
  const post = allBlogPosts.find((p) => p.slug === slug);
  
  // Find all posts that are NOT the current one.
  const otherPosts = allBlogPosts.filter((p) => p.slug !== slug).slice(0, 2); // Show 2 other posts

  // If no post is found, show a "Not Found" message
  if (!post) {
    return (
      <div className="min-h-screen bg-white pt-32 pb-16 px-6 text-center">
        <title>Post Not Found - Techpack Creators</title>
        <meta name="description" content="Sorry, we couldn't find that post." />
        <h1 className="text-4xl font-bold mb-4">Post Not Found</h1>
        <p className="text-lg">Sorry, we couldn't find that post.</p>
      </div>
    );
  }

  // If we found the post, display it!
  return (
    <div className="min-h-screen bg-white pt-32 pb-16 px-6 sm:px-10 lg:px-16">
      
      <title>{`${post.title} - Techpack Creators`}</title>
      <meta name="description" content={post.description} />

      <div className="container mx-auto max-w-3xl">
        
        {/* 1. The Post Title */}
        <h1 className="text-4xl md:text-5xl font-bold font-montserrat mb-2 text-gray-900">
          {post.title}
        </h1>

        {/* --- THIS IS THE NEW DATE --- */}
        <p className="text-gray-500 text-base font-montserrat mb-6">
          Published on {post.date}
        </p>
        {/* --- END OF NEW DATE --- */}
        
        {/* 2. The Post Image */}
        <img
          src={post.img}
          alt={post.title}
          className="w-full h-auto rounded-2xl shadow-lg mb-8"
        />

        {/* 3. The Full Post Content */}
        <div
          className="text-gray-700 font-montserrat text-lg space-y-4"
          dangerouslySetInnerHTML={{ __html: post.fullContent }}
        />

        {/* --- "READ MORE" SECTION --- */}
        <div className="mt-16 pt-12 border-t border-gray-200">
          <h2 className="text-3xl font-bold font-montserrat mb-8 text-gray-900">
            Keep Reading
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {otherPosts.map((otherPost) => (
              <a 
                href={`/blog/${otherPost.slug}`} 
                key={otherPost.slug} 
                className="block"
                target="_blank" // Opens in a new tab
                rel="noopener noreferrer"
              >
                <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition duration-300 h-full">
                  <img src={otherPost.img} alt={otherPost.title} className="w-full h-40 object-cover" />
                  <div className="p-6">
                    <h3 className="text-xl font-bold mb-2 font-montserrat text-gray-800">{otherPost.title}</h3>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
        
      </div>
    </div>
  );
}

export default SinglePostPage;